module.exports = __webpack_public_path__ + "img/calendar-icon.b2016783.png";